import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "ImmersiveReaderStore" */ './lazyIndex'),
    { name: 'ImmersiveReaderStore' }
);

export const lazyShowInImmersiveReader: LazyAction<
    typeof lazyIndex.showInImmersiveReader,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.showInImmersiveReader);

// Non-delayed loaded exports
export { getStore } from './store/Store';
